import { InjectionToken } from '@angular/core';

import type { Data } from 'src/app/utils/models/data.interface';

export const modalDataRef = new InjectionToken<Data>('ModalData');
